import { render, staticRenderFns } from "./webManage.vue?vue&type=template&id=39c82462&"
import script from "./webManage.vue?vue&type=script&lang=js&"
export * from "./webManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports